import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useParams } from "react-router-dom";
import { getCustomerDetails, updateCustomer } from "../../helpers/http_customers_requests";
import DynamicFormPage from "../../components/DynamicFormPage";
import { brazilian_states } from "../../data/general_variables";
import { useQuery } from "@tanstack/react-query";
import { getPriceGroups } from "../../helpers/http_price_groups_requests";

export default function CustomerUpdate() {

    const navigate = useNavigate();

    const [formData, setFormData] = useState({});

    const { id } = useParams();


    const formatOptions = (data) => data?.data?.data?.data?.map(item => ({ value: item.id, label: item.name + ` (18K: ${item.high_gold_index} e 10K: ${item.low_gold_index})` }));

    const priceGroupsQuery = useQuery({ queryKey: ['getPriceGroups'], queryFn: getPriceGroups, staleTime: 1000 * 5 });

    const priceGroups = formatOptions(priceGroupsQuery);

    const formFieldList = [
        {
            title: "Dados de Fiscais",
            fields: [
                {
                    name: "complete_name",
                    label: "Nome Completo",
                    type: "text",
                    required: true,
                },
                {
                    name: "cnpj",
                    label: "CNPJ",
                    type: "text",
                    mask: "cpf_cnpj",
                    required: true,
                },
                {
                    name: "state_registration",
                    label: "Inscrição Estadual",
                    type: "number",
                },
                {
                    name: "social_reason",
                    label: "Razão Social",
                    type: "text",
                    required: true,
                },
                {
                    name: "whatsapp_number",
                    label: "Número de Whatsapp",
                    type: "text",
                    mask: "phone",
                    required: true,
                },
                {
                    name: "email",
                    label: "E-mail Institucional",
                    type: "text",
                    required: true,
                },
                {
                    name: "is_active",
                    label: "Status de Cliente",
                    type: "switch",
                    required: true,
                },
                {
                    name: "observation",
                    label: "Observação",
                    type: "text",
                    multiline: true,
                    rows: 5,
                    fullWidth: true,
                },
                {
                    name: "has_cnpj_certificate",
                    label: "Preview de PDF de CNPJ",
                    type: "preview_pdf",
                    required: true,
                },
                {
                    name: "has_address_proof",
                    label: "Preview de PDF de Endereço",
                    type: "preview_pdf",
                    required: true,
                },
            ]
        },
        {
            title: "Dados do Responsável Geral",
            fields: [
                {
                    name: "main_manager",
                    label: "Nome completo",
                    type: "text",
                    required: true,
                },
                {
                    name: "main_manager_contact",
                    label: "Número de Whatsapp",
                    type: "text",
                    mask: "phone",
                    required: true,
                },
            ]
        },
        {
            title: "Dados do Responsável Financeiro",
            fields: [
                {
                    name: "financial_manager",
                    label: "Nome completo",
                    type: "text",
                    required: true,
                },
                {
                    name: "financial_manager_contact",
                    label: "Número de Whatsapp",
                    type: "text",
                    mask: "phone",
                    required: true,
                },
            ]
        },
        {
            title: "Catálogo e Financeiro",
            fields: [
                {
                    name: "has_catalog",
                    label: "Catálogo",
                    type: "switch",
                    required: true,
                },
                {
                    name: "price_group",
                    label: "Grupo de Índices",
                    type: "select",
                    required: true,
                    options: priceGroups
                },
                {
                    name: "catalog_slug",
                    label: "Chave de Catálogo (URL)",
                    type: "text",
                    required: true,
                },
            ]
        },
        {
            title: "Endereço",
            fields: [
                {
                    name: "zip_code",
                    label: "CEP",
                    type: "text",
                    mask: "zipcode",
                    required: true,
                },
                {
                    name: "address",
                    label: "Endereço",
                    type: "text",
                    required: true,
                },
                {
                    name: "address_number",
                    label: "Número",
                    type: "text",
                    required: true,
                },
                {
                    name: "complement",
                    label: "Complemento",
                    type: "text",
                },
                {
                    name: "neighborhood",
                    label: "Bairro",
                    type: "text",
                    required: true,
                },
                {
                    name: "city",
                    label: "Cidade",
                    type: "text",
                    required: true,
                },
                {
                    name: "state",
                    label: "Estado",
                    type: "select",
                    required: true,
                    options: brazilian_states
                }
            ]
        },

    ];

    useEffect(() => {
        getCustomerDetails(id, setFormData);
    }, [id]);

    const handleSubmit = (data) => {
        updateCustomer(data, () => navigate('/clientes'));
    };

    return <DynamicFormPage initialData={formData} title={"Clientes - Atualizar"} onSubmit={handleSubmit} formFieldList={formFieldList} avatarUpload onCancel={() => navigate(-1)} />;
};
